// extracted by mini-css-extract-plugin
export default {"btnLogin":"ModalForgotPassword_btnLogin__iNmOt","divStep":"ModalForgotPassword_divStep__IUZ7f"};